<template>
  <div class="content">
    <div style="display: none!important;">
      <electron-vue-printer ref="electronVuePrinter" :show="true" :options="options" :rotateType="rotateType"
        @webview-ready="Printer" :silent="true">
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node">
      <div class="text-center" v-if="printer.file_name!=null"><img style="width: 100px"
          :src="axios.defaults.baseURL+'api/v1/uploads/'+printer.file_name"></div>
      <h5>
        <div class="text-center" v-if="print_type != ''"><b>{{ print_type }}</b></div>
        <div class="text-center" v-if="sklad_name">
          <b>{{ sklad_name.name }}</b>
        </div>
      </h5>
      <table class="table table-bordered"
        style="font-size: 11px;background: none!important;font-weight: bold;width: 268px!important;">
        <th>#</th>
        <th>{{$t('Номи')}}</th>
        <th>Cўм</th>
        <th>Доллар</th>
        <tbody>
          <tr v-for="(item, index) in results" :key="index" v-if="item.end_total!=0 || item.end_total_dollar!=0">
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td class="end">{{item.end_total|numFormat}}</td>
            <td class="end">{{item.end_total_dollar|numFormat}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import html2canvas from 'html2canvas';
  import VueQRCodeComponent from 'vue-qr'
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  import { setTimeout } from "timers";
  export default {
    name: "Printchek",
    components: {
      electronVuePrinter, htmlToImage,
      qrCode: VueQRCodeComponent
    },
    data() {
      return {
        print: 'false',
        axiosRess: { data: false },
        print_type: '',
        summ: 0,
        summ_dollar: 0,
        printer: '',
        results: [],
        sklad_name: null,
        rotateType: 0,
        options: {
          offsetX: 0,
          offsetY: 0,
          imageWidth: 300
        },
        indexx: 'not',
        qarz: 0,
        qarz_dollar: 0,
        imgURL: null,
        axiosRes: {
          qarzdorlik: false,
          sklad: false,
          printName: false
        }
      };
    },
    async updated() {
      if (this.print == 'print') {
        this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
        await this.$refs.electronVuePrinter.print(this.dataUrl);
      }
    },
    created: function () {
      this.Data();
      this.GetPrinterName();
      if (localStorage.getItem("print_type")) {
        this.print_type = localStorage.getItem("print_type");
      }
    },
    methods: {
      Test(index) {
        if (index + 1 == this.results.length && this.axiosRes.sklad) {
          console.log('keldi');
          this.indexx = 'start';
        }
      },
      GetPrinterName() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
        }).then(function (response) {
          if (response.data.data != null) {
            self.axiosRes.printName = true
            self.printer = JSON.parse(response.data.data);
          }
        });
      },
      Starprinting(data) {
        if (data == true && this.imgURL) {
          localStorage.removeItem("print_type");
          window.close();
        }
        // }else{
        //   this.Starprinting(true) 
        // }
      },
      Data() {
        let self = this;
        var datas = {
          datetime1: 0,
          datetime2:
            parseInt(
              new Date().valueOf().toString().slice(0, 10)
            ) + 86399,
          sklad_id: parseInt(localStorage.getItem('sklad_id')),
          price_type: "dollar",
          kontragent_id: null,
        };
        axios({
          method: "post",
          url: "api/v1/report/kontragent",
          data: datas,
        }).then(function (response) {
          self.results = response.data;
          self.summ = 0;
          self.summ_dollar = 0;
          self.Mysklad();
          self.results.forEach(function (key, value) {
            self.summ += key.end_total;
            self.summ_dollar += key.end_total_dollar;
          });
        });
      },
      async Printer() {
        let self = this;
        if (self.axiosRes.sklad && self.axiosRes.printName) {
          var node = document.getElementById("my-node");
          const scale = 10; // Kattalashtirish miqdori
          const width = node.clientWidth * scale;
          const height = node.clientHeight * scale;
          node.style.height = node.scrollHeight + 250 + "px";
          await htmlToImage
            .toSvg(document.getElementById("my-node"))
            .then(function (dataUrl) {
              self.dataUrl = dataUrl;
              self.print = 'print';
              self.imgURL = dataUrl;
              setTimeout(() => {
                self.data_await()
              }, 1000);
            })
            .catch(function (error) {
              console.error("oops, something went wrong!", error);
            });
        } else {
          console.log('no')
          setTimeout(() => {
            self.Printer();
          }, 1000);
        }
      },

      Mysklad() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/sklads/id/" + parseInt(localStorage.getItem('sklad_id'))
        }).then(function (response) {
          self.axiosRes.sklad = true;
          self.sklad_name = response.data;
        });
      },
      Datetime() {
        var d = new Date();
        var dt = d.getDate();
        var month = d.getMonth() + 1;
        var hour = d.getHours();
        var minut = d.getMinutes();
        var sekund = d.getSeconds();
        if (month < 10) {
          month = "0" + month;
        }
        if (dt < 10) {
          dt = "0" + dt;
        }
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minut < 10) {
          minut = "0" + minut;
        }
        if (sekund < 10) {
          sekund = "0" + sekund;
        }

        return dt + "." + month + "." + d.getFullYear() + " " + hour + ":" + minut + ":" + sekund;
      },
      data_await() {
        let self = this;
        if (self.imgURL && self.axiosRes.sklad && self.axiosRes.printName) {
          self.Starprinting(true)
        } else {
          self.data_await()
        }

      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Ostatka(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    }
  };
</script>
<style scoped>
  #my-node div,
  #my-node li,
  #my-node b,
  #my-node h5 {
    /* font-size: 16px; */
  }

  #my-node {
    image-rendering: crisp-edges; /* Yaxshi sifat uchun */
  text-rendering: geometricPrecision; /* Matnning aniqroq chiqishi uchun */
    -webkit-font-smoothing: antialiased; /* Matn sifatini yaxshilash uchun */
    padding: 0 22px 0 0 !important;
    /* border: 1px solid; */
    width: 278px;
    /* height: 100vh!important; */
  }

  img {
    image-resolution: 300dpi;
  }

  h5 {
    font-weight: bold;
    font-size: 13px;
    color: black;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid black !important;
  }

  ul {
    list-style: none;
    border-bottom: 1px dotted;
    text-align: left;
    padding: 0;
    margin: 0;
    font-size: 12px;
    color: black;
  }

  ul>li {
    padding-right: 6px;
  }
</style>